import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import head from './head';//导入模块化store
import head2 from './head2';//导入模块化store



const store= new Vuex.Store({
  modules: {  //使用模块化管理
    head1: head,
    head2: head2,


  }
})

//返回store对象
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js